import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { values } from "@/mocks/stats";

export default function TrustSection() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24" aria-labelledby="trust-section">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <SectionHeading
                id="trust-section"
                eyebrow="平台机制"
                title="我们把来源保护放在第一位"
                description="提供线索的人，不应该承担额外的风险。爆料51 在流程设计上优先处理身份脱敏、权限分级与信息留痕，让每一条线索都被谨慎对待。"
              />
            </Reveal>
            <Reveal delay={120}>
              <div className="mt-8 rounded-lg border border-secondary-200 bg-secondary-50 p-5">
                <div className="flex items-start gap-3">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                    <i className="ri-shield-keyhole-line text-xl" />
                  </span>
                  <div>
                    <h3 className="font-heading text-sm font-bold text-secondary-900">来源保护四原则</h3>
                    <p className="mt-2 text-sm leading-relaxed text-secondary-800">
                      默认匿名 · 信息脱敏 · 权限分级 · 全程留痕。你可以选择只提供关键资料，不留下真实姓名与联系方式。
                    </p>
                  </div>
                </div>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {values.map((item, index) => (
                <Reveal key={item.title} delay={index * 80}>
                  <div className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-accent-300">
                    <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-50 text-primary-600">
                      <i className={`${item.icon} text-xl`} />
                    </span>
                    <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}